import TechnologyHighlights from "./_components/technology-highlights";

export default TechnologyHighlights;
